import { Image, ImageProps } from "expo-image";
import { Avatar, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

const DEFAULT_SIZE = 60;

type Props = ImageProps & {
  size?: number;
  fallbackIcon: string;
};

export default function ImageWithFallback({
  size = DEFAULT_SIZE,
  fallbackIcon,
  ...props
}: Props) {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  if (props.source) {
    return (
      <Image
        {...props}
        style={[
          tailwind("rounded-full"),
          { height: size, width: size },
          props.style,
        ]}
      />
    );
  } else {
    return (
      <Avatar.Icon
        size={size}
        icon={fallbackIcon}
        style={{ backgroundColor: colors.surfaceDisabled }}
        color={colors.onSurfaceDisabled}
      />
    );
  }
}
